import React, { useState } from 'react';
import Modal from 'styled-react-modal';

import GenericModal from './GenericModal';
import { useStore } from '../../context/appContext';

const StyledModal = Modal.styled`
  width: 15rem;
  // height: 15rem;
  max-height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  background-color: ${(p) => p.theme.background};
  padding: 1rem;
`;

function ModalComponent() {
  const { setModal, modal } = useStore();

  const [opacity, setOpacity] = useState(0);

  const handleCloseModal = (e) => {
    setOpacity(0);
    setModal({
      open: false,
      type: modal.type,
    });
  };

  const afterOpen = () => {
    setTimeout(() => {
      setOpacity(1);
    }, 100);
  };

  const beforeClose = () => {
    return new Promise((resolve) => {
      setOpacity(0);
      setTimeout(resolve, 300);
    });
  };

  return (
    <StyledModal
      isOpen={modal.open}
      afterOpen={afterOpen}
      beforeClose={beforeClose}
      onBackgroundClick={handleCloseModal}
      onEscapeKeydown={handleCloseModal}
      opacity={opacity}
      backgroundProps={{ opacity }}
      allowScroll={false}
    >
      <GenericModal modalType={modal.type} extraMessage={modal.extraMessage} />
    </StyledModal>
  );
}

export default ModalComponent;
